import { Provider } from "react-redux";
import Head from "next/head";
import ResponsiveAppBar from "components/appbar/ResponsiveAppBar";
import Footer from "components/footer/Footer";
import { store } from "redux-toolkit/store";
import useAuth from "hooks/auth/useAuth";
import ThemeProvider from "../theme";
import "styles/globals.css";
import Loading from "components/common/Loading";

export default function App({ Component, pageProps }) {
  const { currentUser, isLoading } = useAuth();
  if (isLoading) {
    return <Loading />;
  }

  return (
    <Provider store={store}>
      <ThemeProvider>
        <Head>
          <title>Պրոգնոզ</title>
          {/* Meta Tags for SEO */}
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          {/* Favicon */}
          <link rel="icon" href="/logo.svg" />
          <meta property="og:type" content="website" />
          <meta
            name="keywords"
            content="prognos, predictions, predictors, կանխատեսումներ, կանխատեսում, կանխատեսող, Պրոգնոզ"
          />
        </Head>
        <ResponsiveAppBar currentUser={currentUser} />
        <div
          className="h-max-screen mt-[24px] md:px-[124px]"
          style={{ fontFamily: "Noto Sans Armenian" }}
        >
          <Component {...pageProps} />
        </div>
        <Footer currentUser={currentUser} />
      </ThemeProvider>
    </Provider>
  );
}
